import * as React from 'react'
import { TrainingCourse } from '../../molecules/training-course'
import { CourseMap } from '../../molecules/training-course/factory/constants'
import { detectWebviewOs } from '../../../utilities/userAgent'
import { visitDeeplink, initializeWebViewInfo } from '../../../webview'
import { markTrainingCourseComplete } from '../../../actions/dx-training/effects'
import { Options } from '../../../actions/dx-training/types'
import { DxTrainingCourseReduxState } from '../../../reducers/dx-training'
import { OsTypes } from '../../../webview/types'
import Button from '@doordash/component-button'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { trackInAppTrainingCourse } from '../../../events'
import { SlideProps } from '../../../components/molecules/training-course/factory/types'

type TrainingPageProps = TrainingPageStateProps & TrainingPageOwnProps

interface TrainingPageStateProps {
  markTrainingCourseComplete?: (options: Options) => void
  application?: unknown
  dxTrainingCourse?: DxTrainingCourseReduxState
  trackTrainingCourse?: SlideProps['trackTrainingCourse']
}

interface TrainingPageOwnProps {
  courseId: string
}

interface TrainingPageState {
  isError: boolean
}

export const COURSE_ID_PARAM = 'courseId'
const START_SLIDE_INDEX = 0

const IOS_IN_APP_TRAINING_DEEPLINK = `comdoordashdriver://trainingcourse`
const ANDROID_IN_APP_TRAINING_DEEPLINK = `dddriver://trainingcourse`

class DxTrainingPage extends React.Component<
  TrainingPageProps,
  TrainingPageState
> {
  constructor(props: TrainingPageProps) {
    super(props)
    this.state = {
      isError: false,
    }
  }

  public render() {
    const { courseId, trackTrainingCourse, dxTrainingCourse } = this.props
    const { isError } = this.state
    const country = get(this.props.application, 'country')

    if (!country) return null

    return (
      <TrainingCourse
        country={country}
        onClose={this.onClose}
        onSubmit={this.onSubmit}
        onAnimationEnd={this.onAnimationEnd}
        trackTrainingCourse={trackTrainingCourse}
        buttonState={this.getButtonStatus()}
        courseId={parseInt(courseId, 10) as CourseMap}
        currentSlide={START_SLIDE_INDEX}
        isError={isError}
        dxTrainingCourse={dxTrainingCourse}
      />
    )
  }

  protected onClose = () => {
    const deeplink = this.getDeeplink('canceled')
    visitDeeplink(deeplink)
  }

  protected onSubmit = async () => {
    // call API here
    const { markTrainingCourseComplete, courseId } = this.props
    const { token } = await initializeWebViewInfo()
    markTrainingCourseComplete({ token, courseId: parseInt(courseId, 10) })
  }

  protected onAnimationEnd = (status?: 'SUCCESS' | 'ERROR') => {
    const deeplink = this.getDeeplink('completed')
    switch (status) {
      case 'SUCCESS':
        visitDeeplink(deeplink)
        break
      case 'ERROR':
        this.setState({ isError: true })
        break
    }
  }

  protected getDeeplink = (status: 'canceled' | 'completed') => {
    const os = detectWebviewOs()
    const { courseId } = this.props

    switch (os) {
      case OsTypes.iOS:
        return `${IOS_IN_APP_TRAINING_DEEPLINK}?status=${status}&course_id=${courseId}`
      case OsTypes.Android:
        return `${ANDROID_IN_APP_TRAINING_DEEPLINK}?status=${status}`
    }
    return null
  }

  protected getButtonStatus = () => {
    const { dxTrainingCourse } = this.props

    if (dxTrainingCourse.isSubmitting) {
      return Button.States.Loading
    }
    if (dxTrainingCourse.isSubmitted) {
      return Button.States.Success
    }
    if (dxTrainingCourse.error) {
      return Button.States.Error
    }
    return Button.States.Default
  }
}

const mapStateToProps = state => {
  return {
    application: state.application,
    dxTrainingCourse: state.dxTrainingCourse,
  }
}

const mapDispatchToProps = {
  markTrainingCourseComplete,
  trackTrainingCourse: trackInAppTrainingCourse,
}

export default connect(mapStateToProps, mapDispatchToProps)(DxTrainingPage)
